"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SpecialFilterValues = exports.DATA_TYPE = exports.GSIs = exports.Comparison = void 0;
var Comparison;
(function (Comparison) {
    Comparison["IGNORE"] = "IGNORE";
    Comparison["EQUAL_TO"] = "EQUAL_TO";
    Comparison["NOT_EQUAL_TO"] = "NOT_EQUAL_TO";
    Comparison["GREATER_THAN"] = "GREATER_THAN";
    Comparison["GREATER_THAN_OR_EQUAL_TO"] = "GREATER_THAN_OR_EQUAL_TO";
    Comparison["LESS_THAN"] = "LESS_THAN";
    Comparison["LESS_THAN_OR_EQUAL_TO"] = "LESS_THAN_OR_EQUAL_TO";
})(Comparison = exports.Comparison || (exports.Comparison = {}));
var GSIs;
(function (GSIs) {
    GSIs["GSI1"] = "GSI1";
    GSIs["GSI2"] = "GSI2";
    GSIs["GSI3"] = "GSI3";
    GSIs["DATA_TYPE"] = "GSIDATATYPE";
    GSIs["DEL"] = "GSIDEL";
})(GSIs = exports.GSIs || (exports.GSIs = {}));
/**
 * A carbon copy of our database's schema, this enumeration should always reflect all the
 * data types available to us. It should only change upon changes to our data schema.
 */
var DATA_TYPE;
(function (DATA_TYPE) {
    DATA_TYPE["USER"] = "USER";
    DATA_TYPE["ROLE"] = "ROLE";
    DATA_TYPE["ROLE_USER"] = "ROLE_USER";
    DATA_TYPE["PERMISSION"] = "PERMISSION";
    DATA_TYPE["COURSE"] = "COURSE";
    DATA_TYPE["PROGRAM"] = "PROGRAM";
    DATA_TYPE["DELIVERY"] = "DELIVERY";
    DATA_TYPE["SUBJECT"] = "SUBJECT";
    DATA_TYPE["SUBJECT_PROGRAM"] = "SUBJECT_PROGRAM";
    DATA_TYPE["ACCESS_TOP"] = "ACCESS_TOP";
    DATA_TYPE["ACCESS"] = "ACCESS";
    DATA_TYPE["PRECEDENT"] = "PRECEDENT";
    DATA_TYPE["PRECEDENT_USER"] = "PRECEDENT_USER";
    DATA_TYPE["APPLICANT"] = "APPLICANT";
    DATA_TYPE["CREDENTIAL"] = "CREDENTIAL";
    DATA_TYPE["APPLICATION"] = "APPLICATION";
    DATA_TYPE["CREDIT"] = "CREDIT";
    DATA_TYPE["APPLICATION_USER"] = "APPLICATION_USER";
    DATA_TYPE["ARTICULATION"] = "ARTICULATION";
    DATA_TYPE["ARRANGEMENT"] = "ARRANGEMENT";
    DATA_TYPE["COMMENT"] = "COMMENT";
    DATA_TYPE["HISTORY"] = "HISTORY";
    DATA_TYPE["CONFIG"] = "CONFIG";
    DATA_TYPE["CONFIG_COGNITO"] = "CONFIG_COGNITO";
    DATA_TYPE["WORKFLOW_DEFINITION"] = "WORKFLOW_DEFINITION";
    DATA_TYPE["WORKFLOW_PREVIOUS_STATE"] = "WORKFLOW_PREVIOUS_STATE";
    DATA_TYPE["NOTIFICATION"] = "NOTIFICATION";
    DATA_TYPE["NOTIFICATION_TEMPLATE"] = "NOTIFICATION_TEMPLATE";
    DATA_TYPE["CONFIG_SLA"] = "CONFIG_SLA";
    DATA_TYPE["CONFIG_CRON"] = "CONFIG_CRON";
    DATA_TYPE["DISREGARDED_CREDENTIAL"] = "DISREGARDED_CREDENTIAL";
    DATA_TYPE["FORM_SCHEMA"] = "FORM_SCHEMA";
    DATA_TYPE["RULE"] = "RULE";
    DATA_TYPE["RULE_RESULT"] = "RULE_RESULT";
    DATA_TYPE["RULE_TEMPLATE"] = "RULE_TEMPLATE";
})(DATA_TYPE = exports.DATA_TYPE || (exports.DATA_TYPE = {}));
var SpecialFilterValues;
(function (SpecialFilterValues) {
    SpecialFilterValues["NONE"] = "NONE";
    SpecialFilterValues["ALL"] = "ALL";
})(SpecialFilterValues = exports.SpecialFilterValues || (exports.SpecialFilterValues = {}));
//# sourceMappingURL=common.js.map